

// import React, { useEffect, useState, useMemo, useCallback } from "react";
// import axios from "axios";
// import { RiDeleteBin6Line, RiEdit2Line } from "react-icons/ri";
// import { useAuth } from "../context/AuthContext";
// import { API } from "../components/config";

// const API_BASE = `${API}/planeacion`;

//   export default function LogrosList({
//   filtro,
//   onSelectLogro,
//   logroActivo
// }) {
//   const { user, token } = useAuth();

//   const [logros, setLogros] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [newLogro, setNewLogro] = useState({
//     titulo: "",
//     descripcion: ""
//   });

//   const api = useMemo(() => {
//     const instance = axios.create({
//       baseURL: API_BASE,
//       withCredentials: true
//     });

//     instance.interceptors.request.use((config) => {
//       if (token)
//         config.headers.Authorization = `Bearer ${token}`;

//       if (user?.tenant_id)
//         config.headers["X-Tenant-ID"] = user.tenant_id;

//       if (user?.sede_id)
//         config.headers["X-Sede-ID"] = user.sede_id;

//       return config;
//     });

//     return instance;
//   }, [token, user]);

//   const filtrosCompletos =
//     !!(
//       filtro?.grado &&
//       filtro?.grupo &&
//       filtro?.materia_id &&
//       filtro?.periodo_id &&
//       filtro?.item_id
//     );

//   /* =======================================================
//      CARGAR LOGROS
//   ======================================================= */

//   const cargarLogros = useCallback(async () => {

//     if (!filtrosCompletos) {
//       setLogros([]);
//       return;
//     }

//     setLoading(true);

//     try {

//       console.log("============== FILTROS ==============");
//       console.log({
//         profesor_id: user.id,
//         grado: filtro.grado,
//         grupo: filtro.grupo,
//         materia_id: filtro.materia_id,
//         periodo_id: filtro.periodo_id,
//         item_id: filtro.item_id
//       });

//       const { data } = await api.get("/logros", {
//         params: {
//           profesor_id: user.id,
//           grado: filtro.grado,
//           grupo: filtro.grupo,
//           materia_id: filtro.materia_id,
//           periodo_id: filtro.periodo_id,
//           item_id: filtro.item_id
//         }
//       });

//       console.log("============== LOGROS ==============");
//       console.log(data);

//       setLogros(Array.isArray(data) ? data : []);

//     } catch (err) {

//       console.error("Error cargando logros:", err);

//       setLogros([]);

//     } finally {

//       setLoading(false);

//     }

//   }, [
//     api,
//     filtro,
//     filtrosCompletos,
//     user.id
//   ]);

//   useEffect(() => {
//     cargarLogros();
//   }, [cargarLogros]);

//   /* =======================================================
//      CREAR
//   ======================================================= */

//   const handleCreate = async () => {

//     if (!newLogro.titulo.trim()) {
//       alert("Ingrese un título");
//       return;
//     }

//     try {

//       await api.post("/logros", {
//         titulo: newLogro.titulo,
//         descripcion: newLogro.descripcion,
//         profesor_id: user.id,
//         ...filtro
//       });

//       setNewLogro({
//         titulo: "",
//         descripcion: ""
//       });

//       cargarLogros();

//     } catch (err) {

//       console.error(err);

//       alert("Error creando logro");

//     }

//   };

//   /* =======================================================
//      EDITAR
//   ======================================================= */

//   const handleEdit = async (e, logro) => {

//     e.stopPropagation();

//     const titulo = prompt(
//       "Editar título",
//       logro.titulo
//     );

//     if (!titulo || titulo === logro.titulo) return;

//     try {

//       await api.put(`/logros/${logro.id}`, {
//         titulo,
//         descripcion: logro.descripcion
//       });

//       cargarLogros();

//     } catch (err) {

//       console.error(err);

//       alert("Error actualizando");

//     }

//   };

//   /* =======================================================
//      ELIMINAR
//   ======================================================= */

//   const handleDelete = async (e, id) => {

//     e.stopPropagation();

//     if (!window.confirm("¿Eliminar logro?")) return;

//     try {

//       await api.delete(`/logros/${id}`);

//       if (logroActivo?.id === id) {
//         onSelectLogro(null);
//       }

//       cargarLogros();

//     } catch (err) {

//       console.error(err);

//       alert("Error eliminando");

//     }

//   };

//   return (
//     <div className="box">

//       <h3>🎯 Logros</h3>

//       {!filtrosCompletos ? (

//         <p className="muted">
//           Seleccione todos los filtros.
//         </p>

//       ) : (

//         <>
//           <div className="form small">

//             <input
//               placeholder="Título del logro"
//               value={newLogro.titulo}
//               onChange={(e) =>
//                 setNewLogro({
//                   ...newLogro,
//                   titulo: e.target.value
//                 })
//               }
//             />

//             <button onClick={handleCreate}>
//               ➕
//             </button>

//           </div>

//           <div className="list">

//             {loading ? (

//               <p>Cargando...</p>

//             ) : logros.length === 0 ? (

//               <p>No existen logros.</p>

//             ) : (

//               logros.map((logro) => (

//                 <div
//                   key={logro.id}
//                   className={`list-item selectable ${
//                     logroActivo?.id === logro.id
//                       ? "active"
//                       : ""
//                   }`}
//                   onClick={() => onSelectLogro(logro)}
//                 >

//                   <strong>{logro.titulo}</strong>

//                   <div className="actions">

//                     <button
//                       onClick={(e) =>
//                         handleEdit(e, logro)
//                       }
//                     >
//                       <RiEdit2Line />
//                     </button>

//                     <button
//                       onClick={(e) =>
//                         handleDelete(e, logro.id)
//                       }
//                     >
//                       <RiDeleteBin6Line />
//                     </button>

//                   </div>

//                 </div>

//               ))

//             )}

//           </div>

//         </>

//       )}

//     </div>
//   );

// }

//

import React, { useEffect, useState, useMemo, useCallback } from "react";
import axios from "axios";
import { RiDeleteBin6Line, RiEdit2Line } from "react-icons/ri";
import { useAuth } from "../context/AuthContext";
import { API } from "../components/config";

const API_BASE = `${API}/planeacion`;

export default function LogrosList({
  filtro,
  onSelectLogro,
  logroActivo
}) {
  const { user, token } = useAuth();

  const [logros, setLogros] = useState([]);
  const [loading, setLoading] = useState(false);

  const [newLogro, setNewLogro] = useState({
    titulo: "",
    descripcion: ""
  });

  const api = useMemo(() => {
    const instance = axios.create({
      baseURL: API_BASE,
      withCredentials: true
    });

    instance.interceptors.request.use((config) => {
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      if (user?.tenant_id) {
        config.headers["X-Tenant-ID"] = user.tenant_id;
      }

      if (user?.sede_id) {
        config.headers["X-Sede-ID"] = user.sede_id;
      }

      return config;
    });

    return instance;
  }, [token, user]);

  const filtrosCompletos = Boolean(
    filtro?.grado &&
    filtro?.grupo &&
    filtro?.materia_id &&
    filtro?.periodo_id &&
    filtro?.item_id
  );

  /* =======================================================
     CARGAR LOGROS
  ======================================================= */

  const cargarLogros = useCallback(async () => {

    if (!filtrosCompletos) {
      setLogros([]);
      return;
    }

    setLoading(true);

    try {

      console.log("============== FILTROS ==============");
      console.log({
        profesor_id: user.id,
        grado: filtro.grado,
        grupo: filtro.grupo,
        materia_id: filtro.materia_id,
        periodo_id: filtro.periodo_id,
        item_id: filtro.item_id
      });

      const { data } = await api.get("/logros", {
        params: {
          profesor_id: user.id,
          grado: filtro.grado,
          grupo: filtro.grupo,
          materia_id: filtro.materia_id,
          periodo_id: filtro.periodo_id,
          item_id: filtro.item_id
        }
      });

      console.log("============== RESPUESTA BACKEND ==============");
      console.log(data);

      const lista =
        Array.isArray(data?.logros)
          ? data.logros
          : Array.isArray(data)
          ? data
          : [];

      console.log("============== LOGROS CARGADOS ==============");
      console.log(lista);

      setLogros(lista);

    } catch (err) {

      console.error("Error cargando logros:", err);

      setLogros([]);

    } finally {

      setLoading(false);

    }

  }, [
    api,
    filtro,
    filtrosCompletos,
    user.id
  ]);

  useEffect(() => {
    cargarLogros();
  }, [cargarLogros]);

  /* =======================================================
     CREAR
  ======================================================= */

  const handleCreate = async () => {

    if (!newLogro.titulo.trim()) {
      alert("Ingrese un título");
      return;
    }

    try {

      await api.post("/logros", {
        titulo: newLogro.titulo,
        descripcion: newLogro.descripcion,
        profesor_id: user.id,
        ...filtro
      });

      setNewLogro({
        titulo: "",
        descripcion: ""
      });

      await cargarLogros();

    } catch (err) {

      console.error(err);

      alert("Error creando logro");

    }

  };

  /* =======================================================
     EDITAR
  ======================================================= */

  const handleEdit = async (e, logro) => {

    e.stopPropagation();

    const titulo = prompt("Editar título", logro.titulo);

    if (!titulo || titulo === logro.titulo) return;

    try {

      await api.put(`/logros/${logro.id}`, {
        titulo,
        descripcion: logro.descripcion
      });

      await cargarLogros();

    } catch (err) {

      console.error(err);

      alert("Error actualizando");

    }

  };

  /* =======================================================
     ELIMINAR
  ======================================================= */

  const handleDelete = async (e, id) => {

    e.stopPropagation();

    if (!window.confirm("¿Eliminar logro?")) return;

    try {

      await api.delete(`/logros/${id}`);

      if (logroActivo?.id === id) {
        onSelectLogro(null);
      }

      await cargarLogros();

    } catch (err) {

      console.error(err);

      alert("Error eliminando");

    }

  };

  return (
    <div className="box">

      <h3>🎯 Logros</h3>

      {!filtrosCompletos ? (

        <p className="muted">
          Seleccione todos los filtros.
        </p>

      ) : (

        <>
          <div className="form small">

            <input
              placeholder="Título del logro"
              value={newLogro.titulo}
              onChange={(e) =>
                setNewLogro({
                  ...newLogro,
                  titulo: e.target.value
                })
              }
            />

            <button onClick={handleCreate}>
              ➕
            </button>

          </div>

          <div className="list">

            {loading ? (

              <p>Cargando...</p>

            ) : logros.length === 0 ? (

              <p>No existen logros.</p>

            ) : (

              logros.map((logro) => (

                <div
                  key={logro.id}
                  className={`list-item selectable ${
                    logroActivo?.id === logro.id
                      ? "active"
                      : ""
                  }`}
                  onClick={() => onSelectLogro(logro)}
                >

                  <strong>{logro.titulo}</strong>

                  <div className="actions">

                    <button
                      onClick={(e) => handleEdit(e, logro)}
                    >
                      <RiEdit2Line />
                    </button>

                    <button
                      onClick={(e) => handleDelete(e, logro.id)}
                    >
                      <RiDeleteBin6Line />
                    </button>

                  </div>

                </div>

              ))

            )}

          </div>

        </>

      )}

    </div>
  );
}